
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/why-attend",
      function () {
        return require("private-next-pages/sa/why-attend.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/why-attend"])
      });
    }
  